import React, { useState } from 'react';
import ReclaimPurchaseTransactionCodeView from './ReclaimPurchaseTransactionCodeView';
import { useTranslation } from 'react-i18next';
import crmservices from '../../wsclient/';
import ModalAlert from '../../components/ModalAlert';
import Loading from '../../components/Loading';

export default function ReclaimPurchaseTransactionCode(props) {
    const { t } = useTranslation();

    const [showLoading, onShowLoading] = useState(false);
    const [error, setError] = useState({
        showAlert: false,
        title: '',
        message: '',
        status: '',
    });
    const [transactionCode, setTransactionCode] = useState(undefined);
    const [validation, setValidation] = useState();

    const onHandleChange = (value) => {
        setTransactionCode(value);
    }

    const onValidate = () => {
        var isValid = transactionCode ? true: false;
        setValidation(isValid);
        return isValid;
    }

    const onSubmit = async (value) => {
        console.log('onSubmit ReclaimPurchase value=', value);
        let isValidate = onValidate();
        if(!isValidate) return isValidate;
        onShowLoading(true);
        try {
            let body = {
                transaction_code: transactionCode,
            }
            var result = await crmservices.contacts.reclaimPurchase(body);
            if (result.code === 'OK') {
                setTransactionCode(undefined);
                showAlert(true, t('RECLAIM_PURCHASE_TRANSACTION_SUCCESS'), t('SUCCESS'));
            } else {
                showAlert(true, t('RECLAIM_PURCHASE_TRANSACTION_FAIL'), t('ERROR'));
            }
        } catch (error) {
            showAlert(true, t('EXCEPTION_PROCESS'), t('ERROR'));
        }
        onShowLoading(false);
    }

    const showAlert = (status, message, title) => {
        onShowLoading(false);
        setError({
            showAlert: true,
            title: title,
            message: message,
            status: status,
        });
    }

    const onCloseAlert = async () => {
        onShowLoading(false);
        setError({
            showAlert: false,
            title: '',
            message: '',
            status: '',
        });
    }

    return (
        <>
            <ReclaimPurchaseTransactionCodeView
                open={props.open}
                transactionCode={transactionCode}
                onSubmit={onSubmit}
                onHandleChange={onHandleChange}
                onClose={props.onClose}
            />
            <ModalAlert
                open={error.showAlert}
                onClose={onCloseAlert}
                hideHeader={true}
                message={error.message}
                error={error.status}
                title={error.title}
            />
            <Loading showLoading={showLoading} />
        </>
    )
}